import { Component, inject } from '@angular/core';
import { DialogActionsComponent, DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { CapitalizePipe, ClientService, DropdownLoaderDirective } from 'shared';
import { ComboBoxComponent, DropDownFilterSettings, FilterDirective } from '@progress/kendo-angular-dropdowns';
import { debounceTime, Subject } from 'rxjs';
import { FormFieldComponent } from '@progress/kendo-angular-inputs';
import { LabelComponent } from '@progress/kendo-angular-label';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@progress/kendo-angular-buttons';

@Component({
  selector: 'rc-supplier-credit-note-link-client-modal',
  imports: [
    FormFieldComponent,
    LabelComponent,
    TranslateModule,
    CapitalizePipe,
    ComboBoxComponent,
    AsyncPipe,
    FilterDirective,
    FormsModule,
    ButtonComponent,
    DialogActionsComponent,
    DropdownLoaderDirective,
  ],
  templateUrl: './supplier-credit-note-link-client-modal.component.html',
  styleUrl: './supplier-credit-note-link-client-modal.component.scss',
})
export class SupplierCreditNoteLinkClientModalComponent extends DialogContentBase {
  #clientService = inject(ClientService);

  #filterSubject = new Subject<{ search: string; type: 'clients' }>();

  clients$ = this.#clientService.getClients();
  selectedClient: string | null = null;

  filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };

  constructor() {
    const dialog = inject(DialogRef);

    super(dialog);

    this.#filterSubject.pipe(debounceTime(300)).subscribe((value) => {
      if (value.type === 'clients') {
        this.clients$ = this.#clientService.findClients(`name=${value.search}`);
      }
    });
  }

  onSearch(value: string, field: 'clients') {
    this.#filterSubject.next({ search: value, type: field });
  }

  onSubmit() {
    this.dialog.close({ isSuccessFull: true, result: this.selectedClient });
  }
}
